import { forwardRef } from 'react';
import TextareaAutosize, { type TextareaAutosizeProps } from 'react-textarea-autosize';
import { cn } from '../../lib/cn';

export interface AutoTextareaProps extends Omit<TextareaAutosizeProps, 'minRows' | 'maxRows'> {
  invalid?: boolean;
  minRows?: number;
  maxRows?: number;
}

export const AutoTextarea = forwardRef<HTMLTextAreaElement, AutoTextareaProps>(
  function AutoTextarea({ className, invalid = false, minRows = 2, maxRows = 30, ...rest }, ref) {
    return (
      <TextareaAutosize
        ref={ref}
        minRows={minRows}
        maxRows={maxRows}
        className={cn(
          'w-full px-3 py-2 rounded-lg text-base',
          'bg-surface-2 border-0 resize-none',
          'transition-shadow duration-150',
          'placeholder:text-hint',
          'focus:outline-none focus:ring-2',
          invalid ? 'ring-2 ring-destructive/60 focus:ring-destructive/60' : 'focus:ring-ink/70',
          className,
        )}
        {...rest}
      />
    );
  },
);
